'use strict';

var extractHex = require('../../../../../../../../_virtual/extractHex.cjs');

var hasRequiredExtractHex;

function requireExtractHex () {
	if (hasRequiredExtractHex) return extractHex.__exports;
	hasRequiredExtractHex = 1;

	/**
	 * extract the colour hex code from an alpha hex code
	 */ const extractHex$1 = (alphaHex)=>{
	    const hex = alphaHex.slice(0, 7);
	    return hex;
	};

	extractHex.__exports.extractHex = extractHex$1;
	
	return extractHex.__exports;
}

exports.__require = requireExtractHex;
//# sourceMappingURL=extractHex.cjs.map
